export default "__VITE_ASSET__D_N4NBdM__"